/** Valor de fecha que puede venir de Firestore (Timestamp) o ser Date. */
export type FirestoreDate = Date | { toDate(): Date } | { seconds: number; nanoseconds: number };

/** Tipo de presentación del anuncio. */
export enum AnnouncementType {
  POPUP = "POPUP",
  BANNER = "BANNER",
  TOAST = "TOAST",
}

/** Acción al interactuar con el anuncio. */
export enum AnnouncementAction {
  NONE = "NONE",
  NAVIGATE_TO_PRODUCT = "NAVIGATE_TO_PRODUCT",
  NAVIGATE_TO_CATEGORY = "NAVIGATE_TO_CATEGORY",
  NAVIGATE_TO_OFFER = "NAVIGATE_TO_OFFER",
  NAVIGATE_TO_URL = "NAVIGATE_TO_URL",
  OPEN_CART = "OPEN_CART",
}

/** Disparador del anuncio. */
export enum AnnouncementTrigger {
  ON_APP_OPEN = "ON_APP_OPEN",
  ON_PAGE_VISIT = "ON_PAGE_VISIT",
  ON_TIME_DELAY = "ON_TIME_DELAY",
  MANUAL = "MANUAL",
}

/** Anuncio / notificación in-app. */
export interface Announcement {
  id: string;
  title: string;
  message: string;
  imageUrl?: string;
  type: AnnouncementType;
  action: AnnouncementAction;
  actionData?: string;
  buttonText?: string;
  trigger: AnnouncementTrigger;
  isActive: boolean;
  startDate?: FirestoreDate;
  endDate?: FirestoreDate;
  maxShowsPerUser?: number;
  createdBy?: string;
  createdAt: FirestoreDate;
  updatedAt: FirestoreDate;
}
